import React from 'react'
import bestOffenseVideo from "../../assets/video/best-offense-1.webm"
import Button from '../ui/Button.tsx'
import useFlickerEffect from '../../hooks/useFlickerEffect.ts';

const Banner = () => {
    const activeClass = useFlickerEffect();
    // const videoRef = useRef<HTMLVideoElement>(null);

    return (
        <>
            <section id='banner' className={` relative 
                lg:before:absolute 
                lg:before:right-0
                lg:before:bg-right
                lg:before:bg-[url('../src/assets/images/righteffeect3.png')]  
                lg:before:top-[550px] xl:before:top-[600px] 
                lg:before:z-10
                lg:before:max-w-[480px] xl:before:max-w-[555px]
                lg:before:w-full 
                lg:before:h-[1400px] xl:before:h-[1570px]
                lg:before:bg-no-repeat 
                lg:before:bg-contain
                ${activeClass && 'lg:before:animate-flicker'}
                `}>
                <div className="bg-[url('../src/assets/images/HERO-BG.png')] bg-no-repeat bg-center bg-cover w-full h-full pb-[20px] xl:pb-[75px] " >
                    <div className="container relative lg:after:absolute lg:after:right-[40px] lg:before:left-[40px] lg:after:h-[54px] lg:after:w-[23px] lg:before:absolute lg:before:bg-[url('../src/assets/icons/leftarrow.svg')] lg:after:bottom-0 lg:after:bg-[url('../src/assets/icons/rightarrow.svg')] lg:before:h-[52px] lg:before:w-[23px]  pb-8 pt-[47px]">
                        <div className='relative flex justify-center items-center h-full pt-[37px] '>
                            <div className="  max-w-[998px] w-full lg:before:bg-[url('../src/assets/images/bannerStar.png')] lg:before:animate-spin-sclaeUp lg:before:bg-no-repeat lg:before:absolute lg:before:top-[-130px] lg:max-[1170px]:before:left-[60px] lg:before:left-0 lg:before:h-[45px] lg:after:bg-contain lg:before:w-[45px]  mt-[110px] mb-[122px] relative  lg:after:bottom-[-125px] lg:after:absolute lg:max-[1170px]:after:right-[60px] lg:after:right-0  lg:after:bg-[url('../src/assets/images/bannerStar.png')] lg:after:animate-spin-sclaeUp lg:after:bg-no-repeat lg:after:w-[45px] lg:after:h-[45px]" >
                                <div className="text-center z-20 relative lg:before:top-[-70.19px] lg:before:absolute  xl:before:right-[-53.19px] lg:before:right-[0px] lg:before:bg-[url('../src/assets/icons/righticon.svg')] lg:before:h-[22px] lg:before:w-[22px] lg:after:bg-[url('../src/assets/icons/lefticon.svg')] lg:after:w-[22px] lg:after:h-[22px] lg:after:absolute lg:after:left-0  lg:after:bottom-[-53.79px] max-w-[1067px] mx-auto" >
                                    <video 
                                        className='w-[537.55px] h-[98.67px] md:w-[624.98px] md:h-[129.99px] lg:w-[854.45px] lg:h-[167.95px] mx-auto object-contain' 
                                        src={bestOffenseVideo} 
                                        autoPlay 
                                        loop 
                                        muted 
                                        playsInline
                                    />
                                    <h2 className='font-inter text-body_text py-8 text-[16px] lg:text-[18px] leading-[140%]' >Forged by Israel’s elite cyber forces, <br className='md:block hidden lg:block'></br>
                                    our platform mimics real-life <br className='md:hidden block lg:hidden'></br> adversaries— before hackers strike</h2>
                                    {/* <div className='pt-[20px] md:pt-0 inline' >
                                        <Button href='#contactsection' varient="solid" buttonClass="px-[22px] md:pt-[17px] md:pb-[15px] pl-[30px] pr-[34px]  font-bold text-nowrap leading-4">
                                            Book A live demo
                                        </Button>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Banner